import { Love, Hate, Fear, Happy, CryingFace } from "../../../../../src/components";
import * as React from 'react';
export default {
  Love,
  Hate,
  Fear,
  Happy,
  CryingFace,
  React
};